/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDrag } from '@use-gesture/react';
import { Html } from '@react-three/drei';
import { useThree, useLoader } from '@react-three/fiber';

import * as actionCreator from '../../../../action/index';
import { updateCupolas } from '../../../../action';
import { const_var, params } from '../../../../redux/reducers/reducer';


import useOutsideClick from '../../../../hooks/useOutsideClick';
import { MetalStripeImg } from '../../../../utils/Textures';
import { textureAnisotropy } from '../../../../utils/Functions';
import { CupolaOverlap } from '../../../../utils/Overlap'

import WithWindows from './WithWindows';
import WithoutWindows from './WithoutWindows';
import OutLineSection from './OutLineSection';
import { cupolaValidation } from '../../../../utils/Validation.js';

import { getPosition } from '../../../../utils/GetToolTipPosition'

const CupolaModel = ({ item, overlapArr, setOverlapArr }) => {

    const editRef = useRef();
    const dispatch = useDispatch();
    const get = useThree((state) => state.get)
    const isShowEditIconSection = useSelector(state => state.reducer.isShowEditIconSection)
    const selectedCmpType = useSelector(state => state.reducer.selectedCmpType)

    const [isDrag, setIsDrag] = useState(false);
    const [scaleValue, setScaleValue] = useState(1)
    const [positionZ, setPositionZ] = useState(item.positionZ)
    const [startPositionZ, setStartPositionZ] = useState(item.positionZ);
    const [isHovered, setIsHovered] = useState(false);
    const [isDelBtnClicked, setIsDelBtnClicked] = useState(false);
    const [isCloned, setIsCloned] = useState(false);
    const [canClone, setCanClone] = useState(true);

    const texture = const_var.metalTexture;
    const textureBody = texture.clone();
    textureAnisotropy(get().gl, textureBody, 1, 2, 0)
    textureBody.needsUpdate = true;
    
    const textureRoof = texture.clone();
    textureAnisotropy(get().gl, textureRoof, 2, 80, Math.PI / 2)
    textureRoof.needsUpdate = true;

    const distance = (const_var.controls!=undefined && const_var.controls.getDistance!=undefined)? const_var.controls.getDistance([0, 0, 0]):[0, 0, 0];
    const componentDistance = const_var.componentDistance + 0.5;

    const length = item.length;
    const height = 3;
    const pitch = params.p_w / 2 * params.p_r_p / 12;
    const camPosX = const_var.camera?.position?.x;

    let offset = 1
    if(camPosX >= 0) offset = 1;
    else if(camPosX < 0) offset = -1;

    const positionY = useMemo(() => {
        if(params.p_r_s === 1){
            return (params.p_h + params.p_w / 2 * (params.p_r_p / 12) + 0.38)
        } else if(params.p_r_s === 2){
            return (params.p_h + params.p_w / 2 * (params.p_r_p / 12) + 0.01)
        } else if(params.p_r_s === 3) {
            return (params.p_h + params.p_w / 2 * (params.p_r_p / 12) + 0.01)
        }
    
    }, [params.p_h, params.p_w, params.p_r_p, params.p_r_s]);

    const limitZ = useMemo(() => {
        const componentDistance = const_var.componentDistance + 0.5
        const min = -params.p_d / 2 + length / 2 + componentDistance;
        const max = params.p_d / 2 - length / 2 - componentDistance;

        return {
            min, max
        }
    
    }, [params.p_d, length])

    const bind = useDrag(
        ({ down, delta, first, event, movement: [mx, my] }) => {
            event.stopPropagation();
            
            if (first) {
                setStartPositionZ(positionZ);
            }
            
            setIsDrag(down);

            if (down === true) {
                const_var.controls.enableRotate = false;
                get().gl.domElement.style.cursor = 'move';
                const_var.cupolaUniqueId = item.uniqueId

                const nextPositionZ = startPositionZ + (-mx * offset) * ((distance) / 1000);
                    if (nextPositionZ < limitZ.min) {
                        setPositionZ(limitZ.min)
                    } else if (nextPositionZ > limitZ.max) {
                        setPositionZ(limitZ.max)
                    } else {
                        setPositionZ(nextPositionZ);
                    }
            } else {
                let isFind = false;
                
                if (const_var.cupolas.length > 0) {
                    const sortCupolaArr = (const_var.cupolas.sort((a, b) => a.positionZ - b.positionZ)).filter(child => child.uniqueId !== item.uniqueId)
                    
                    const overlapObj = sortCupolaArr.find(cupola => {
                        const distance = Math.abs(positionZ - cupola.positionZ);
                        if (distance < item.width / 2 + cupola.width / 2 + componentDistance) {
                            return cupola
                        }

                        return null;
                    })                    
                    
                    if (!!overlapObj) {
                        isFind = true;
                        
                    } else {
                        isFind = false;
                    }
                }
                
                if (isFind) {
                    setPositionZ(startPositionZ);
                } else {
                    setStartPositionZ(positionZ);
                    dispatch(updateCupolas(item.uniqueId, positionZ))
                }
                const_var.controls.enableRotate = true;
                get().gl.domElement.style.cursor = 'auto'
            }
            removeFocus()
        }
    )
    
    const onClickCupolaComponent = (e) => {
        e.stopPropagation();
        dispatch(actionCreator.setSelectedCmpType('cupola'))
        dispatch(actionCreator.setIsShowEditIconSection(true));
        const_var.timer = setTimeout(() => {
            removeFocus()
        },10000)
    }

    const removeFocus = () => {
        if(const_var.showComponentEditBox == false){
            if((document.getElementsByClassName("delete-tooltip") != undefined && document.getElementsByClassName("delete-tooltip")[0]) || (document.getElementsByClassName("warning-tooltip") != undefined && document.getElementsByClassName("warning-tooltip")[0])){
                
            }else{
                dispatch(actionCreator.setSelectedCmpType('none'))
                dispatch(actionCreator.setIsShowEditIconSection(false));
                clearTimeout(const_var.timer);
                setCanClone(true);
            }
        }
    }

    const handleDeleteClick = () => {
        if(isDelBtnClicked == true){
            setIsDelBtnClicked(false);
            dispatch(actionCreator.setSelectedCmpType('none'));
            dispatch(actionCreator.setIsShowEditIconSection(false));
            clearTimeout(const_var.timer);
        }
    }

    const handleSetCanClone = () => {
        setCanClone(true);
        dispatch(actionCreator.setSelectedCmpType('none'));
        dispatch(actionCreator.setIsShowEditIconSection(false));
        clearTimeout(const_var.timer);
    }

    const cloneComponent = () => {
        let cloneAlerts = document.getElementsByClassName('clone-success-container');
        for (const alert of cloneAlerts) {
            alert.style.display = 'none';
        }
        const isAdd = cupolaValidation(length).isAdd
        setCanClone(isAdd);
        // setTimeout(() => {
        //     setCanClone(true);
        // }, 3000);
        if(const_var.cupolaEntries.length>0){
            let findSelectedCupola = const_var.cupolaEntries.filter(cupola => cupola.uniqueId == item.uniqueId);
            if(findSelectedCupola!=undefined){
                item.price = findSelectedCupola[0].cupola_price 
            }
        }
        if(isAdd){
            setIsCloned(!isCloned);
            setTimeout(() => {
                setIsCloned(false)
            }, 3000);
            dispatch(actionCreator.handleCupola('','clone',item.uniqueId, item))
        } else{
            setIsCloned(false);
        }
    }

    const removeComponent = () => {
        dispatch(actionCreator.handleCupola('','remove',item.uniqueId, item))
    }
    
    const onClickEditButton = (e) => {
        dispatch(actionCreator.handleIconClick(e, item.uniqueId, 'cupola'))
    }

    const addedCupolaPos = useMemo(() => {
        
        if (isCloned) {
            const addedDoorInfo = const_var.cupolas.find(s => s.uniqueId === const_var.cupolaUniqueId)
            
            return [-item.width * 3.45, params.p_h + params.p_w / 2 * params.p_r_p / 12 + height * 2.7, addedDoorInfo.positionZ]
        }
    }, [isCloned, params.p_h, params.p_w, params.p_r_p ])


    // const editCupolaPos = useMemo(() => {
    //     const addedDoorInfo = const_var.cupolas.find(s => s.uniqueId === const_var.cupolaUniqueId)
    //     if(window.innerWidth >= 520){
    //         return [-item.width * 3.45, params.p_h + params.p_w / 2 * params.p_r_p / 12 + height * 2.7, (addedDoorInfo!=undefined)?addedDoorInfo.positionZ:0]
    //     }else{
    //         return [item.width/2, params.p_h + params.p_w/3 * params.p_r_p / 12 + height * 3.2, (addedDoorInfo!=undefined)?addedDoorInfo.positionZ:0]
    //     }
    // },[editMessageCupola , isShowEditIconSection])

    useEffect(() => {
        setPositionZ(item.positionZ);
        setStartPositionZ(item.positionZ);
    }, [item.positionZ])
    
    useEffect(() => {
        if (item.width === 4) {
            setScaleValue(1)
        } else if (item.width === 3) {
          setScaleValue(0.75)
        } else if (item.width === 2) {
          setScaleValue(0.5)
        } else {
          setScaleValue(1)
        }
      }, [item.width])

    useOutsideClick(editRef, (e) => {
        if (!(const_var.showComponentEditBox || const_var.isShowAlert)) setIsDelBtnClicked(false)
        if (const_var.showComponentEditBox || const_var.isShowAlert || !!e.target.innerText) return
        if (const_var.cupolaUniqueId === item.uniqueId) {
            dispatch(actionCreator.setSelectedCmpType('none'))
            dispatch(actionCreator.setIsShowEditIconSection(false));
        }
    });

    useEffect(() => {
        if (selectedCmpType === 'cupola' && isShowEditIconSection && const_var.cupolaUniqueId === item.uniqueId) {
            if (editRef.current) editRef.current.parentElement.parentElement.style.zIndex = 1;
        }
    }, [editRef.current, selectedCmpType, isShowEditIconSection, const_var.isShowAlert, const_var.showComponentEditBox])

    useEffect(() => {
        if (isDrag) {
            if (const_var.cupolas.length > 0) {
                const sortCupolaArr = (const_var.cupolas.sort((a, b) => a.positionZ - b.positionZ)).filter(child => child.uniqueId !== item.uniqueId)
                const overlapArrTemp = CupolaOverlap(sortCupolaArr, item.uniqueId, item.length, positionZ, componentDistance);
                if (JSON.stringify(overlapArrTemp) !== JSON.stringify(overlapArr)) {
                    setOverlapArr(overlapArrTemp);
                }
            }
        } else {
            if (overlapArr.length > 0) {
                setOverlapArr([]);
            }
            if(positionZ !== startPositionZ && !isDrag){
                setPositionZ(startPositionZ)
            } else {
                setPositionZ(positionZ)
            }
        }
    
    }, [componentDistance, isDrag, positionZ, startPositionZ])
    
    useEffect(() => {
        if ( (item.positionZ < limitZ.min || item.positionZ > limitZ.max)) {
            const newArray = const_var.cupolas.filter(e => e.uniqueId !== item.uniqueId);
            dispatch(actionCreator.updateCupolasArray(newArray));
        }
    }, [limitZ.min, limitZ.max]);

    const [delPosition, setDelPosition] = useState('right');
    const setDelTooltipPosition = (e) => {
        const tooltipSize = window.innerWidth > 992 ? [285, 211] : [215, 172];
        setDelPosition(getPosition(e, tooltipSize));
    }

    const [warnPosition, setWarnPosition] = useState('right');
    const setWarnTooltipPosition = (e) => {
        const tooltipSize = window.innerWidth > 992 ? [285, 53] : [215, 74];
        setWarnPosition(getPosition(e, tooltipSize));
    }

    return (
        <>
            <group
                {...bind()}
                position={[0, positionY, isDrag ? positionZ : startPositionZ]}
                scale={scaleValue}
                onClick={onClickCupolaComponent}
                onPointerOver={(e) => {e.stopPropagation(); if(const_var.controls.enableRotate) {setIsHovered(true)}}}
                onPointerOut={() => setIsHovered(false)}
            >
                <group key={item.uniqueId} name={`cupola${item.uniqueId}`}>
                    {item.userData.compType === 'with_windows' && <WithWindows isOverlap={overlapArr.find((child) => child === item.uniqueId) === undefined ? false : true} textureBody={textureBody} textureRoof={textureRoof} />}
                    {item.userData.compType === 'without_windows' && <WithoutWindows isOverlap={overlapArr.find((child) => child === item.uniqueId) === undefined ? false : true} textureBody={textureBody} textureRoof={textureRoof} />}
                </group>

                {((isDrag) || (isHovered) || (selectedCmpType === 'cupola' && isShowEditIconSection && item.uniqueId === const_var.cupolaUniqueId)) && <OutLineSection isDeleted={isDelBtnClicked} canClone={canClone}/>}
            </group>
            
            {(selectedCmpType === 'cupola' && isShowEditIconSection && const_var.cupolaUniqueId === item.uniqueId) && (
                <Html ref={editRef} position={[item.width, params.p_h + pitch + 1.45 * height * scaleValue, positionZ]} className='edit-btn-section' >
                    <div id='cupola-edit-icon' onClick={() => {setCanClone(true); setIsDelBtnClicked(false); onClickEditButton();}} className='edit-icon-container'>
                        {
                            !const_var.showCupolaEditBox ?
                            <i className='ico-icon-edit-ico'></i>:
                            <i className='ico-icon-close'></i>
                        }
                    </div>
                    <div onClick={(e) => {setDelTooltipPosition(e); setCanClone(true); setIsDelBtnClicked(true);}}  className='delete-icon-container'>
                        <i className='ico-icon-delete' style={{color: isDelBtnClicked ? '#D5121A' : '#000000'}}></i>
                        {
                            isDelBtnClicked &&
                            <div className={`delete-tooltip ${delPosition} `}>
                                <div className="alert-title">ALERT!!</div>
                                <div className="alert-content">Are you sure you want to delete this Cupola?</div>
                                <button className="btn btn-danger" onClick={(e) => removeComponent(const_var.doorUniqueId)}>
                                    YES DELETE
                                </button>
                                <i className='ico-icon-close' onClick={(e) => {e.stopPropagation(); handleDeleteClick(false)}}></i>
                            </div>
                        }
                    </div>
                    <div onClick={(e)=> {setWarnTooltipPosition(e);  setIsDelBtnClicked(false); cloneComponent(const_var.doorUniqueId, e);}} className='clone-icon-container' >
                        <i className='ico-icon-duplicate-ico' style={{color: !canClone ? '#FF8900' : '#000000'}}></i>
                        {
                            !canClone &&
                            <div className={`warning-tooltip ${warnPosition}`}>
                                <div className='warning-content'>There is no space to add Cupola</div>
                                <i className='ico-icon-close' onClick={(e) => {e.stopPropagation(); handleSetCanClone();}}></i>
                            </div>
                        }
                    </div>
                </Html>
            )}
            
            {
                isCloned && 
                <Html className='clone-success-container' position={addedCupolaPos}>
                    <div>
                        <span>
                            {'Cupola Cloned Successfully'}
                        </span>
                        <span>
                            <i className='ico-icon-close' onClick={() => setIsCloned(false)}></i>
                        </span>
                    </div>
                </Html>
            }
        </>
    );
}

export default CupolaModel;
